<template>
  <div class="container connect-dashboard">
    <!-- TODO: Can't scroll on first visit -->
    <edit-product-modal @product-updated="refreshData" />
    <manage-addons-modal @addons-updated="refreshData" />
    <header>
      <h1 v-html="companyName" />
      <a
        href="https://dashboard.stripe.com/login"
        target="_blank"
        class="btn"
      >
        Go To Stripe <svg-vue icon="icons/external-link" />
      </a>
      <registration-links />
    </header>
    <main>
      <stat-boxes />
      <h2>
        My SEO Software
        <a
          v-if="products && products[0]"
          href="javascript:;"
          @click="editProduct(products[0])"
        >
          <svg-vue icon="icons/edit_pencil" />
        </a>
      </h2>
      <section
        v-for="(product, index) in products"
        :key="index"
        class="products"
      >
        <product-card
          :key="index"
          :product="product"
          :allow-edit="true"
          product-type-description="Just the software"
        />
        <product-card
          v-if="product.supportAddon"
          product-type-description="Supplementary support add-on"
          :product="product.supportAddon"
        />
      </section>
      <h2>
        My Add-ons
        <a
          href="javascript:;"
          @click="manageAddons({addons, products})"
        >
          <svg-vue icon="icons/edit_pencil" />
        </a>
        <svg-vue
          v-if="missingAddonPrices"
          icon="icons/hazard_triangle"
          class="addons-warning tooltipster"
          title="Some of your addons require updating."
        />
      </h2>
      <section class="addons">
        <product-card
          v-for="(addon, index) in addons"
          :key="index"
          :product="addon"
          :product-type-description="billingPeriodDisplay(addon.billingPeriod)+ ' add-on'"
        />
      </section>
    </main>
  </div>
</template>

<script>
import RegistrationLinks from './dashboard/RegistrationLinks';
import ProductCard from './dashboard/ProductCard';
import EditProductModal from './modals/EditProductModal';
import ManageAddonsModal from './modals/ManageAddonsModal';
import StatBoxes from './includes/StatBoxes';
import Swal from "sweetalert2";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    RegistrationLinks,
    ProductCard,
    EditProductModal,
    ManageAddonsModal,
    StatBoxes,
  },
  computed: {
    ...mapGetters('stripeConnectDashboard', [
      'companyName',
      'products',
      'addons',
      'registrationLinks',
      'showProductModal',
      'showAddonsModal',
    ]),
    ...mapGetters('addonManager', [
      'missingAddonPrices',
    ]),
  },
  mounted() {
    this.fetchCompanyInfo();
  },
  methods: {
    ...mapActions('stripeConnectDashboard', [
      'fetchCompanyInfo',
      'fetchRegistrationLinks',
      'closeModals',
      'editProduct',
      'manageAddons',
    ]),
    refreshData() {
      this.fetchCompanyInfo();
      this.fetchRegistrationLinks();
    },
    billingPeriodDisplay(billingPeriod) {
      switch (billingPeriod) {
        case 'MONTH':
          return 'Monthly';
        case 'YEAR':
          return 'Annual';
        default:
          return 'One-off';
      }
    },
    clipboard(link) { // TODO: Globalise this, see ReadyToGo.vue
      if (!window.isSecureContext) {
        Swal.fire({
          type: 'error',
          title: 'Insecure connection',
          html: 'Unable to write to clipboard, please copy and paste:<br>'+link,
        })
      }
      navigator.clipboard.writeText(link);
      Swal.fire('Copied to clipboard!');
    },
  }
}
</script>

<style lang="scss" scoped>
  .connect-dashboard {
    padding-bottom: 2rem;

    header {
      display:flex;
      align-items: center;

      h1 {
        flex-grow: 1;
        font-size: 2.5rem;
        font-weight: 700;
      }

      .btn {
        border: 1px solid #37B2A8;
        color: #37B2A8;

        svg {
          width: 1rem;
        }
      }
    }

    main {
      > h2 {
        font-size: 2rem;
        font-weight: 500;
        margin-top: 2.813rem;
        display: flex;
        align-items: center;
        gap: 1rem;

        &:first-of-type {
          margin-top: 0;
        }

        a {
          height: 30px;
          width: 30px;
          background: #6ECADA;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;

          svg {
            height: 16px;
            width: 20px;

            :deep(path) {
              stroke: #FFFFFF;
            }
          }
        }

        .addons-warning {
          height: 30px;
          width: 30px;
          :deep(path) {
            stroke: var(--negative-color);
          }
        }
      }

      section {
        &.products,
        &.addons {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 2.313rem;

          .product {
            flex-grow: 1;
            flex-basis: 48%;

            &.new {
              padding: 2rem;
              background: none;
              border: 2px dashed #37B2A8;
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: background 0.3s ease;

              h3 {
                color: #37B2A8;
                font-weight: 700;
                font-size: 1.5rem;
                margin: 0;
              }

              &:hover {
                background: rgba(55, 178, 168, 0.1);
              }
            }
          }
        }


        &.addons {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 2.313rem;

          .product {
            flex-grow: 1;
            flex-basis: 30%;
          }
        }

        @media screen and (max-width: 1199px) {
          &.addons {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media screen and (max-width: 767px) {
          &.products,
          &.addons {
            grid-template-columns: repeat(1, 1fr);
          }
        }
      }
    }
  }
</style>
